import React from 'react';

type Props = {
  color?: string;
} & typeof defaultProps;

const defaultProps = {
  color: '#1EC252',
};

const PreviewDocIcon = function PreviewDocIcon(props: Props) {
  const { color } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none" className="preview-doc-icon-svg">
      <path d="M10.3998 0H3.1998C1.8758 0 0.799805 1.076 0.799805 2.4V3.8C0.799805 4.242 1.1578 4.6 1.5998 4.6C2.0418 4.6 2.3998 4.242 2.3998 3.8V2.4C2.3998 1.958 2.7578 1.6 3.1998 1.6H10.3998C10.8418 1.6 11.1998 1.958 11.1998 2.4V8.8C11.1998 9.242 10.8418 9.6 10.3998 9.6H7.7998C7.3578 9.6 6.9998 9.958 6.9998 10.4C6.9998 10.842 7.3578 11.2 7.7998 11.2H10.3998C11.7238 11.2 12.7998 10.124 12.7998 8.8V2.4C12.7998 1.076 11.7238 0 10.3998 0Z" fill={color} />
      <path d="M8.60001 3.2002H5.00001C4.55801 3.2002 4.20001 3.5582 4.20001 4.0002C4.20001 4.4422 4.55801 4.8002 5.00001 4.8002H8.60001C9.04201 4.8002 9.40001 4.4422 9.40001 4.0002C9.40001 3.5582 9.04201 3.2002 8.60001 3.2002Z" fill={color} />
      <path d="M8.59983 6.40039H6.99983C6.55783 6.40039 6.19983 6.75839 6.19983 7.20039C6.19983 7.64239 6.55783 8.00039 6.99983 8.00039H8.59983C9.04183 8.00039 9.39983 7.64239 9.39983 7.20039C9.39983 6.75839 9.04183 6.40039 8.59983 6.40039Z" fill={color} />
      <path d="M0 10.5996C0 11.0416 0.358 11.3996 0.8 11.3996C1.242 11.3996 1.6 11.0416 1.6 10.5996V9.33161L4.034 11.7656C4.19 11.9216 4.394 11.9996 4.6 11.9996C4.806 11.9996 5.01 11.9216 5.166 11.7656C5.478 11.4536 5.478 10.9476 5.166 10.6336L2.732 8.19961H4C4.442 8.19961 4.8 7.84161 4.8 7.39961C4.8 6.95761 4.442 6.59961 4 6.59961H2C0.898 6.59961 0 7.49761 0 8.59961V10.5996Z" fill={color} />
    </svg>
  );
};

PreviewDocIcon.defaultProps = defaultProps;

export default PreviewDocIcon;
